import React from "react";
import {Button, Input} from "reactstrap";
import {IExoFilter} from "../../../../store/exo/types";
import MultiTextInput from "../../../../components/Common/MultiTextInput";

interface FilterRowProps {
    filter: IExoFilter;
    disabled?: boolean;
    focusRef?: React.Ref<HTMLInputElement>;
    onChange: (filter: IExoFilter) => void;
    onRemove: () => void;
}

const ExoFilterRow: React.FC<FilterRowProps> = ({filter, disabled = false, focusRef, onChange, onRemove}) => {
    return (
        <div className="d-flex gap-2 align-items-center mb-2">
            <div className="w-25 flex-shrink-0">
                <Input
                    innerRef={focusRef}
                    placeholder="Key *"
                    value={filter.key}
                    disabled={disabled}
                    onChange={e => onChange({...filter, key: e.target.value})}/>
            </div>

            <div className="flex-grow-1">
                <MultiTextInput
                    value={filter.values}
                    disabled={disabled}
                    onChange={values => onChange({...filter, values})}
                    placeholder="Values * (press Enter to add)"/>
            </div>

            <Button
                color="link"
                type="button"
                className="text-danger p-0"
                title="Remove filter"
                disabled={disabled}
                onClick={onRemove}
            >
                <i className="mdi mdi-delete font-size-18"></i>
            </Button>
        </div>
    );
};

export default ExoFilterRow;